import React from 'react';
import Slider from "../../../Carousel/slider"
import './WA.css'



const WA = ()  => {


    return (
        <div className="container-container">
   <Slider />

    </div>
    )

}


export default WA;